<adapt-table #adaptTable
             [responsive]="true"
             [id]="id"
             [bordered]="bordered"
             [resizableColumns]="resizableColumns"
             [reorderableColumns]="reorderableColumns"
             [columnResizeMode]="columnResizeMode"
             [virtualScroll]="virtualScroll"
             [virtualRowHeight]="virtualRowHeight"
             [scrollable]="scrollable"
             [scrollHeight]="scrollHeight"
             [sortable]="sortable"
             [filterable]="filterable"
             [rows]="rows"
             [first]="first"
             [paginator]="isShowPagination"
             [showCurrentPageReport]="isShowPagination"
             [expandedRowTemplate]="expandedRowTemplate"
             [dataKey]="dataKey"
             [loading]="loading"
             [columns]="columnConfig"
             [value]="tableRowData"
             [selection]="selection"
             [selectionMode]="selectionMode"
             [disabledRowSelectionResolver]="disabledRowSelectionResolver"
             [toolbarConfig]="toolbarConfig"
             [tooltipInitialDelayMs]="tooltipInitialDelayMs"
             [wrapCellText]="wrapCellText"
             (selectionChange)="onSelectionChange($event)"
             (export)="onExportAs($event)">
</adapt-table>

<ng-template #dateTemplate let-dataItem="dataItem" let-column="column">
  <div class="cmxa-text-ellipsis"
       [adaptTooltip]="dataItem[column['field']] | date :'d/M/y'"
       [innerHTML]="dataItem[column['field']] ? (dataItem[column['field']] | date :'d/M/y' | underlineMatch : filterText : ' ': true) : '-'">
  </div>
</ng-template>

<ng-template #dateTimeTemplate let-dataItem="dataItem" let-column="column">
  <div [adaptTooltip]="dataItem[column['field']] | date : 'd/M/y, hh:mm:ss a'"
       [innerHTML]="dataItem[column['field']] ? (dataItem[column['field']] | date :'d/M/y, hh:mm:ss a' | underlineMatch : filterText : ' ': true) : '-'">
  </div>
</ng-template>

<ng-template #thumbUpHeaderTitleTemplate>
  <button adapt-button
          id="feedback-positive"
          class="feedback-button"
          btn-type="primary"
          type="button"
          size="xtra-small">
    <span class="d-icon-thumb_up_adapt"></span>
  </button>
</ng-template>

<ng-template #thumbDownHeaderTitleTemplate>
  <button adapt-button
          id="feedback-negative"
          class="feedback-button"
          btn-type="primary"
          type="button"
          size="xtra-small">
    <span class="d-icon-thumb_down_adapt"></span>
  </button>
</ng-template>

<ng-template #tableCellTemplate let-dataItem="dataItem" let-column="column">
  <div [ngClass]="{'cmxa-text-ellipsis': !wrapCellText}"
       [adaptTooltip]="!wrapCellText ? dataItem[column['field']] : null"
       [innerHTML]="dataItem[column['field']] | underlineMatch : filterText : ' ': true">
  </div>
</ng-template>

<ng-template #productStatusCellTemplate let-dataItem="dataItem" let-column="column">
  <div class="cmxa-status-wide-badge"
       [ngClass]="badgeClasses[dataItem.productStatus]"
       [innerHTML]="dataItem[column['field']] | underlineMatch : filterText : ' ': false">
  </div>
</ng-template>

<ng-template #publishingStatusCellTemplate let-dataItem="dataItem" let-column="column">
  <div class="cmxa-status-badge"
       [ngClass]="badgeClasses[dataItem.publishingStatus]"
       [innerHTML]="dataItem[column['field']] | underlineMatch : filterText : ' ': false">
  </div>
</ng-template>

<ng-template #linkCellTemplate let-dataItem="dataItem">
    <a [id]="'cmxa-search-isPublished-' + dataItem.id"
       [href]="host + '/product/' + dataItem.smartNumber"
       target="_blank"
       adapt-button
       btn-type="tertiary"
       [adaptTooltip]="'Redirect to ' +  dataItem.name + ' ' + dataItem.version"
       class="btn btn-link px-0">{{dataItem.smartNumber}}
    </a>
</ng-template>

<ng-template #publishedVersionCellTemplate let-dataItem="dataItem">
  <ng-container *ngIf="dataItem.hasPublishedVersion; else disabledLink">
    <a [id]="'cmxa-search-isPublished-' + dataItem.id"
       [href]="ENV.cmxClientUrl + '?smartNumber=' + dataItem.smartNumber"
       target="_blank"
       adapt-button
       btn-type="tertiary"
       adaptTooltip="View published version"
       class="btn btn-link cmx-view-published-btn">
      <span class="d-icon-arrow_right_eye"></span>
    </a>
  </ng-container>
  <ng-template #disabledLink>
    <button [id]="'cmxa-search-isPublished-' + dataItem.id"
            adapt-button
            btn-type="tertiary"
            adaptTooltip="No published version available on the CMX Client"
            class="btn btn-link disabled cmx-view-published-btn">
      <span class="d-icon-arrow_right_eye"></span>
    </button>
  </ng-template>
</ng-template>

<ng-template #techTypeTableCellTemplate let-dataItem="dataItem" let-column="column">
  <div class="cmxa-text-ellipsis"
       [adaptTooltip]="dataItem | acmCutFieldName : column['field']"
       [innerHTML]="dataItem | acmCutFieldName : column['field'] | underlineMatch : filterText : ' ': true">
  </div>
</ng-template>

<ng-template #masterTechTypeTableCellTemplate let-dataItem="dataItem" let-column="column">
  <div class="cmxa-text-ellipsis"
       [adaptTooltip]="dataItem | arrayToString : column['field'] : 'cmpTypeName'"
       [innerHTML]="dataItem | arrayToString : column['field'] : 'cmpTypeName' : filterText">
  </div>
</ng-template>

<ng-template #dropdownCmpTypeTableCellTemplate let-dataItem="dataItem">
  <ng-container *ngIf="dataItem.cmpTypes.length < 2; else showDropdown">
    <div class="cmxa-text-ellipsis"
         [adaptTooltip]="dataItem.productInstComponentType.cmpTypeName"
         [innerHTML]="dataItem.productInstComponentType.cmpTypeName | underlineMatch : filterText : ' ': true">
    </div>
  </ng-container>
  <ng-template #showDropdown>
    <div class="dropdown"
         adaptDropdown
         [appendToBody]="true"
         [restoreFocusAfterClose]="true">
      <button id="cmxa-dropdown-select-type-for-tech"
              adapt-button
              btn-type="secondary"
              size="xtra-small"
              adaptDropdownToggle
              [innerHTML]="dataItem.productInstComponentType.cmpTypeName | underlineMatch : filterText : ' ': true">
      </button>
      <div class="dropdown-menu"
           adaptDropdownMenu>
        <button *ngFor="let type of dataItem.cmpTypes; let index = index"
                [id]="'cmxa-select-type-for-tech-' + index"
                class="dropdown-item"
                [class.active]="dataItem.productInstComponentType.cmpTypeId === type.cmpTypeId"
                [innerHTML]="type.cmpTypeName | underlineMatch : filterText : ' ': true"
                (click)="changeCmpTypeDropdown(type, dataItem)">
        </button>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #dbNotesTableCellTemplate let-dataItem="dataItem">
  <button id="cmxa-db-notes-icon"
          type="button"
          class="btn btn-link"
          [placement]="'auto'"
          [autoClose]="'outside'"
          [popoverClass]="'acm-table-popover'"
          [adaptPopover]="dbNotesPopoverContent">
    <span class="d-icon-info_circle" aria-hidden="true"></span>
  </button>
  <ng-template #dbNotesPopoverContent>
    <div [innerHTML]="dataItem.note.content"></div>
  </ng-template>
</ng-template>

<ng-template #osNotesTableCellTemplate let-dataItem="dataItem" let-column="column">
  <button id="cmxa-os-notes-icon"
          type="button"
          class="btn btn-link"
          [placement]="'auto'"
          [autoClose]="'outside'"
          [popoverClass]="'acm-table-popover'"
          [adaptPopover]="osNotesPopoverContent">
    <span class="d-icon-info_circle" aria-hidden="true"></span>
  </button>

  <ng-template #osNotesPopoverContent>
    <div [innerHTML]="dataItem.osNote.noteContent"></div>
  </ng-template>
</ng-template>

<ng-template #osDetailsTableCellTemplate let-dataItem="dataItem" let-column="column">
  <button id="cmxa-os-details-icon"
          type="button"
          class="btn btn-link"
          [placement]="'auto'"
          [autoClose]="'outside'"
          [popoverClass]="'acm-table-popover'"
          [adaptPopover]="osDetailsPopoverContent">
    <span class="d-icon-list" aria-hidden="true"></span>
  </button>

  <ng-template #osDetailsPopoverContent>
    <div *ngFor="let category of dataItem['osComponents'] | keyvalue">
      <ng-container *ngIf="(category.value).length > 0">

        <div><b>{{NESTED_OS_TECHS_TITLE[category.key]}} ({{ (category.value).length}}):</b></div>

        <ng-container *ngIf="category.key === NESTED_OS_TECHS.UI_LANG || category.key === NESTED_OS_TECHS.DOCS_LANG; else techTemplate">
            <span *ngFor="let lang of category.value; last as isLast">
              {{lang.name}}<ng-container *ngIf="!isLast">,</ng-container>
            </span>
        </ng-container>

        <ng-template #techTemplate>
          <ul>
            <li *ngFor="let cmp of category.value">
              {{cmp['supplierName'] ? cmp['supplierName'] + ',' : ''}}
              {{cmp['cmpName']}},
              {{cmp['cmpVersion']}},
              {{cmp['cmpArchitecture']}},
              {{cmp['productInstComponentType']['cmpTypeName']}}
            </li>
          </ul>
        </ng-template>
      </ng-container>
    </div>
  </ng-template>
</ng-template>

<ng-template #toolbarTableFilterTemplate>
  <adapt-rx-search id="cmxa-global-table-filter"
                   class="adapt-table-search"
                   [placeholder]="'Filter these results'"
                   [debounceTime]="300"
                   [(ngModel)]="filterText"
                   [searchButton]="searchButton"
                   (ngModelChange)="onFilterTable($event)">
  </adapt-rx-search>
</ng-template>

<ng-template #advancedFilterTemplate>
    <adapt-advanced-filter [appendDropdownToBody]="true"
                           [showTags]="true"
                           [enableSavedFilters]="true"
                           [applyFiltersByUserAction]="true"
                           [filterOptions]="advancedFilterOptions"
                           [selectedFilters]="selectedAdvancedFilters"
                           [savedFilters]="savedFilters"
                           [(activeSavedFilter)]="activeSavedFilter"
                           (activeSavedFilterChange)="onActiveSavedFilterChange($event)"
                           (selectedFiltersChange)="onSelectedAdvancedFiltersChange($event)"
                           (filtersCleared)="onFiltersCleared(selectedAdvancedFilters)"
                           (createNewFilter)="onCreateNewAdvancedFilter($event)"
                           (updateSavedFilter)="onUpdateSavedAdvancedFilter($event)"
                           (deleteSavedFilter)="onDeleteSavedAdvancedFilter($event)"
                           (beforeActiveSavedFilterChange)="onBeforeActiveSavedFilterChange($event)">
    </adapt-advanced-filter>
</ng-template>

<ng-template #inputsForReleaseDateTemplate
             let-filterValue="value"
             let-filterControlsComponent="filterControlsComponent">

  <adapt-rx-radiobutton-group class="advanced-filter__radiobutton-group"
                              [(ngModel)]="pastDaysPresetModel"
                              (ngModelChange)="onReleaseDatePresetChange(pastDaysPresetModel, filterControlsComponent)">
    <adapt-rx-radiobutton name="booleanTypeGroup"
                          class="advanced-filter__radiobutton"
                          [value]="90"
                          [label]="'Past 90 days'">
    </adapt-rx-radiobutton>
    <adapt-rx-radiobutton name="booleanTypeGroup"
                          class="advanced-filter__radiobutton"
                          [value]="180"
                          [label]="'Past 180 days'">
    </adapt-rx-radiobutton>
  </adapt-rx-radiobutton-group>

  <adapt-rx-datetime-range class="advanced-filter__datetime"
                           [inline]="true"
                           [inlineCompact]="true"
                           [inlineLight]="true"
                           [ngModel]="filterValue"
                           (ngModelChange)="onDateTimeTypeFilterOptionModelChange($event, filterControlsComponent)">
  </adapt-rx-datetime-range>
</ng-template>

<!--FEEDBACK TEMPLATE-->
<ng-template #feedbackFilterTemplate>
  <adapt-simple-filter  *ngIf="tableType === FEEDBACK_TABLE_TYPE.ALL || FEEDBACK_TABLE_TYPE.ALL_CLIENT || FEEDBACK_TABLE_TYPE.BY_SN_CLIENT"
                        id="cmxa-filter-feedbk-by-type"
                        class="m-end-4"
                        [filterOptions]="FEEDBACK_SIMPLE_FILTER_OPTIONS.FEEDBACK_TYPE"
                        [texts]="{ initialDropdownAnchorLabel: 'Filter by feedback type' }"
                        (activeFilterOptionChange)="activeFeedbackFilter($event, FEEDBACK_SIMPLE_FILTER_KEY.FEEDBACK_TYPE)">
  </adapt-simple-filter>

  <adapt-simple-filter  *ngIf="tableType === FEEDBACK_TABLE_TYPE.ALL"
                        id="cmxa-filter-feedback-by-source"
                        class="m-end-4"
                        [filterOptions]="FEEDBACK_SIMPLE_FILTER_OPTIONS.SOURCE_APP"
                        [texts]="{ initialDropdownAnchorLabel: 'Filter by source app' }"
                        (activeFilterOptionChange)="activeFeedbackFilter($event, FEEDBACK_SIMPLE_FILTER_KEY.SOURCE_APP)">
  </adapt-simple-filter>
</ng-template>
<ng-template #feedbackTypeTemplate let-column="column" let-dataItem="dataItem" >
  <span [className]= "dataItem[column.field] === FEEDBACK_FORM_TYPE.NEGATIVE ? 'd-icon-minus_circle text-danger' : 'd-icon-plus_circle text-success'" aria-hidden="true"></span>
</ng-template>

<ng-template #descrTemplate let-dataItem="dataItem">
  <ng-container *ngFor="let descr of dataItem.shortDescription">
      • <span [innerHTML]="descr | lowercase | underlineMatch : filterText : ' ': true"></span> <br/>
  </ng-container>
</ng-template>

<ng-template #emailTemplate let-column="column" let-dataItem="dataItem">
  <a [href]="'mailto:' + (dataItem | acmCutFieldName : column['field'])"
     [adaptTooltip]="dataItem | acmCutFieldName : column['field']"
     [innerHTML]="dataItem | acmCutFieldName : column['field'] | underlineMatch : filterText : ' ': true">
  </a>
</ng-template>

<ng-template #pageLinkTemplate let-column="column" let-dataItem="dataItem">
  <a href="{{dataItem[column.field]}}" target="_blank" title="{{dataItem[column.field]}}"
    [innerHTML]="dataItem[column['field']] | underlineMatch : filterText : ' ': true"></a>
</ng-template>

<ng-template #smartNumberTemplate let-column="column" let-dataItem="dataItem">
  <a href="{{host}}/product/{{dataItem[column.field]}}" target="_blank" title="{{dataItem[column.field]}}"
  [innerHTML]="dataItem[column['field']] | underlineMatch : filterText : ' ': true"></a>
</ng-template>

<ng-template #viewEmailButtonTemplate let-dataItem="dataItem">
  <button adapt-button
          [btn-type]="'primary'"
          [size]="'xtra-small'"
          (click)="onViewEmail(dataItem)">
    <span class="d-icon-arrow_right_eye"></span>
    Preview
  </button>
</ng-template>

<ng-template #viewLogButtonTemplate let-dataItem="dataItem">
  <button adapt-button
          [btn-type]="'primary'"
          [size]="'xtra-small'"
          [disabled]="!dataItem.smartNumber"
          (click)="onViewHistoryLog(dataItem)">
    <span class="d-icon-arrow_chart"></span>
    View log
  </button>
</ng-template>

<ng-template #emailsIsAddressedTemplate let-column="column" let-dataItem="dataItem">
    <span *ngIf="dataItem[column.field] != null"
          [ngClass]="{'d-icon-check_adapt text-success': dataItem[column.field] == EMAIL_IS_ADDRESSED.YES,
                      'd-icon-circle_slash_o text-danger': dataItem[column.field] == EMAIL_IS_ADDRESSED.NO}"
          aria-hidden="true">
    </span>
</ng-template>

<ng-template #leftCustomSectionTemplate>
  <div class="text-muted">Preset filters:</div>
  <div adaptSubnav class="w-100">
    <div [adaptSubnavItem]="actionButtonTemplate">
      <ng-template #actionButtonTemplate>
        <button *ngFor="let sharedFilter of sharedSavedAdvancedFilters"
                class="px-1 btn btn-link"
                (click)="activateSharedAdvancedFilter(sharedFilter)">{{sharedFilter.name}}
        </button>
      </ng-template>
    </div>
    <div [adaptSubnavDropdown]></div>
  </div>
</ng-template>

<ng-template #visibleColumnsCustomTemplate>
  <div class="dropdown-item adapt-table-toolbar-dropdown-item"
       tabindex="-1"
       adaptListKeyManagerItem
       [class.ui-state-disabled]="isLastVisibleColumn(column)"
       [ngSwitch]="i"
       *ngFor="let column of columnConfig; let i = index; trackBy: adaptTable.trackByForColumns">

      <div *ngSwitchCase="0"
           class="cmxa-visibility-columns-group-title">DATA INFO
      </div>
      <div *ngSwitchCase="4"
           class="cmxa-visibility-columns-group-title">PRODUCT INFO
      </div>
      <div *ngSwitchCase="14"
           class="cmxa-visibility-columns-group-title">SUPPORT INFO
      </div>
      <div *ngSwitchCase="17"
           class="cmxa-visibility-columns-group-title">FEEDBACK INFO
      </div>

      <adapt-rx-checkbox class="adapt-table-toolbar__column-visibility-control"
                         [adaptRadarDisableEventSending]="false"
                         [label]="column.header"
                         [disabled]="isLastVisibleColumn(column) || column.header === COLUMN_HEADER.PUBLISHING_STATUS"
                         [ngModel]="adaptTable.isColumnVisible(column)"
                         (ngModelChange)="onChangeColumnVisibility($event, column)">
      </adapt-rx-checkbox>
    </div>
</ng-template>

<ng-template #emailManagementFilterTemplate>
  <adapt-simple-filter  id="cmxa-filter-emails-by-type"
                        class="m-end-4"
                        [filterOptions]="EMAIL_SIMPLE_FILTER_OPTIONS.EMAIL_TYPE"
                        [texts]="{ initialDropdownAnchorLabel: 'Filter emails by type' }"
                        (activeFilterOptionChange)="activeFeedbackFilter($event, EMAIL_SIMPLE_FILTER_KEY.EMAIL_TYPE)">
  </adapt-simple-filter>
  <adapt-simple-filter  id="cmxa-filter-emails-by-isAddressed"
                        class="m-end-4"
                        [filterOptions]="EMAIL_SIMPLE_FILTER_OPTIONS.EMAIL_IS_ADDRESSED"
                        [texts]="{ initialDropdownAnchorLabel: 'Filter addressed' }"
                        (activeFilterOptionChange)="activeFeedbackFilter($event, EMAIL_SIMPLE_FILTER_KEY.EMAIL_IS_ADDRESSED)">
</adapt-simple-filter>
</ng-template>
